export const MAX_FILE_SIZE = 52428800